import Vue from 'vue'
import Router from 'vue-router'
import globalUserData from './utils/globalMixin.js'

import Dashboard from '@/modules/dashboard/dashboard.vue'
import Contact from '@/modules/contact/contact.vue'
import User from '@/modules/user/user/user.vue'
import CreateUser from '@/modules/user/user/create.vue'
import ViewUser from '@/modules/user/user/view.vue'
import ErrorPage from '@/modules/errorPage/errorPage.vue'
import Login from '@/modules/login/login.vue'
import Company from '@/modules/company/company.vue'
import CreateCompany from '@/modules/company/create.vue'
import Equipment from '@/modules/equipment/equipment.vue'
import CreateEquipment from '@/modules/equipment/create.vue'
import MachineType from '@/modules/machineType/machineType.vue'
import CreateMachineType from '@/modules/machineType/create.vue'
import Machine from '@/modules/machine/machine.vue'
import CreateMachine from '@/modules/machine/create.vue'
import ViewMachine from '@/modules/machine/view.vue'
import MachineMaintenance from '@/modules/machineMaintenance/machineMaintenance.vue'
import CreateMachineMaintenance from '@/modules/machineMaintenance/create.vue'
import LiveMachineStatus from '@/modules/machineLiveStatus/view.vue'
import JointType from '@/modules/jointType/jointType.vue'
import CreateJointType from '@/modules/jointType/create.vue'
import Polarity from '@/modules/polarity/polarity.vue'
import CreatePolarity from '@/modules/polarity/create.vue'
import QualificationMethod from '@/modules/qualificationMethod/qualificationMethod.vue'
import CreateQualificationMethod from '@/modules/qualificationMethod/create.vue'
import ReferredStandard from '@/modules/referredStandard/referredStandard.vue'
import CreateReferredStandard from '@/modules/referredStandard/create.vue'
import Welder from '@/modules/welder/welder.vue'
import CreateWelder from '@/modules/welder/create.vue'
import ViewWelder from '@/modules/welder/view.vue'
import WeldingProcess from '@/modules/weldingProcess/weldingProcess.vue'
import CreateWeldingProcess from '@/modules/weldingProcess/create.vue'
import WeldingType from '@/modules/weldingType/weldingType.vue'
import CreateWeldingType from '@/modules/weldingType/create.vue'
import Project from '@/modules/project/project.vue'
import CreateProject from '@/modules/project/create.vue'
import ViewProject from '@/modules/project/view.vue'
import WeldingProcedure from '@/modules/weldingProcedure/weldingProcedure.vue'
import CreateWeldingProcedure from '@/modules/weldingProcedure/create.vue'
import WpsAws from '@/modules/weldingProcedure/wpsAws.vue'
import WpsAwsView from '@/modules/weldingProcedure/wpsAwsView.vue'
import WpsAsme from '@/modules/weldingProcedure/wpsAsme.vue'
import WpsAsmeView from '@/modules/weldingProcedure/wpsAsmeView.vue'
import PqrAsme from '@/modules/weldingProcedure/pqrAsme.vue'
import PqrAsmeView from '@/modules/weldingProcedure/pqrAsmeView.vue'
import PqrAws from '@/modules/weldingProcedure/pqrAws.vue'
import PqrAwsView from '@/modules/weldingProcedure/pqrAwsView.vue'
import CreateUserRole from '@/modules/user/userRole/create.vue'
import UserRole from '@/modules/user/userRole/userRole.vue'
import GetAppData from '@/modules/login/getAppData.vue'
import NotAuthorized from '@/modules/errorPage/401.vue'
import Prefix from '@/modules/prefix/prefix.vue'
import CreatePrefix from '@/modules/prefix/create.vue'
import ViewPrefix from '@/modules/prefix/view.vue'
import CqaReport from '@/modules/report/cqaReport.vue'
import MvqaReport from '@/modules/report/mvqaReport.vue'
import WlaReport from '@/modules/report/wlaReport.vue'
import CmaReport from '@/modules/report/cmaReport.vue'
import PcaReport from '@/modules/report/pcaReport.vue'
import MuaReport from '@/modules/report/muaReport.vue'
import PtcaReport from '@/modules/report/ptcaReport.vue'
import CompanyProfile from '@/modules/companyProfile/companyProfile.vue'

Vue.use(Router)

const route = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: { name: 'GetAppData' },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        toolbarTitle: 'DashBoard',
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/about',
      name: 'About',
      component: Contact
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        toolbarTitle: 'User',
        right: ['view_user']
      }
    },
    {
      path: '/user/create',
      name: 'Create User',
      component: CreateUser,
      meta: {
        toolbarTitle: 'Create User',
        right: ['edit_user']
      }
    },
    {
      path: '/user/edit/:id',
      name: 'Edit User',
      component: CreateUser,
      meta: {
        toolbarTitle: 'Edit User',
        right: ['edit_user']
      },
    },
    {
      path: '/user/view/:id',
      name: 'View User',
      component: ViewUser,
      meta: {
        toolbarTitle: 'View User',
        right: ['view_user']
      },
    },
    {
      path: '/userRole',
      name: 'User Role',
      component: UserRole,
      meta: {
        toolbarTitle: 'User Role',
        right: ['view_user_role']
      }
    },
    {
      path: '/userRole/create',
      name: 'Create User Role',
      component: CreateUserRole,
      meta: {
        toolbarTitle: 'Create User Role',
        right: ['edit_user_role']
      }
    },
    {
      path: '/userRole/edit/:id',
      name: 'Edit User Role',
      component: CreateUserRole,
      meta: {
        toolbarTitle: 'Edit User Role',
        right: ['edit_user_role']
      },
    },
    {
      path: '/company',
      name: 'company',
      component: Company,
      meta: {
        toolbarTitle: 'Company',
      }
    },
    {
      path: '/company/create',
      name: 'Create Company',
      component: CreateCompany,
      meta: {
        toolbarTitle: 'Create Company',
      }
    },
    {
      path: '/company/edit/:id',
      name: 'Edit Company',
      component: CreateCompany,
      meta: {
        toolbarTitle: 'Edit Company',
      }
    },
    {
      path: '/equipment',
      name: 'Equipment',
      component: Equipment,
      meta: {
        toolbarTitle: 'Equipment',
        right: ['view_equipment']
      }
    },
    // {
    //   path: '/equipment/create',
    //   name: 'Create Equipment',
    //   component: CreateEquipment,
    //   meta: {
    //     toolbarTitle: 'Create Equipment',
    //     right: ['edit_equipment']
    //   }
    // },
    {
      path: '/equipment/edit/:id',
      name: 'Edit Equipment',
      component: CreateEquipment,
      meta: {
        toolbarTitle: 'Edit Equipment',
        right: ['edit_equipment']
      },
    },
    {
      path: '/machine',
      name: 'Machine',
      component: Machine,
      meta: {
        toolbarTitle: 'Machine',
        right: ['view_machine']
      }
    },
    {
      path: '/machine/create',
      name: 'Create Machine',
      component: CreateMachine,
      meta: {
        toolbarTitle: 'Create Machine',
        right: ['edit_machine']
      }
    },
    {
      path: '/machine/edit/:id',
      name: 'Edit Machine',
      component: CreateMachine,
      meta: {
        toolbarTitle: 'Edit Machine',
        right: ['edit_machine']
      },
    },
    {
      path: '/machine/view/:id',
      name: 'View Machine',
      component: ViewMachine,
      meta: {
        toolbarTitle: 'View Machine',
        right: ['view_machine']
      },
    },
    {
      path: '/machineType',
      name: 'Machine Type',
      component: MachineType,
      meta: {
        toolbarTitle: 'Machine Type',
        right: ['view_machine_type']
      }
    },
    {
      path: '/machineType/create',
      name: 'Create Machine Type',
      component: CreateMachineType,
      meta: {
        toolbarTitle: 'Create Machine Type',
        right: ['edit_machine_type']
      }
    },
    {
      path: '/machineType/edit/:id',
      name: 'Edit Machine Type',
      component: CreateMachineType,
      meta: {
        toolbarTitle: 'Edit Machine Type',
        right: ['edit_machine_type']
      },
    },
    {
      path: '/machineMaintenance',
      name: 'Machine Maintenance',
      component: MachineMaintenance,
      meta: {
        toolbarTitle: 'Machine Maintenance',
        right: ['view_machine_maintenance']
      }
    },
    {
      path: '/machineMaintenance/create',
      name: 'Create Machine Maintenance',
      component: CreateMachineMaintenance,
      meta: {
        toolbarTitle: 'Create Machine Maintenance',
        right: ['edit_machine_maintenance']
      }
    },
    {
      path: '/machineMaintenance/edit/:id',
      name: 'Edit Machine Maintenance',
      component: CreateMachineMaintenance,
      meta: {
        toolbarTitle: 'Edit Machine Maintenance',
        right: ['edit_machine_maintenance']
      },
    },
    {
      path: '/machineLiveStatus',
      name: 'Live Status',
      component: LiveMachineStatus,
      meta: {
        toolbarTitle: 'Live Status',
      }
    },
    {
      path: '/jointType',
      name: 'Joint Type',
      component: JointType,
      meta: {
        toolbarTitle: 'Joint Type',
        right: ['view_joint_type']
      }
    },
    {
      path: '/jointType/create',
      name: 'Create Joint Type',
      component: CreateJointType,
      meta: {
        toolbarTitle: 'Create Joint Type',
        right: ['edit_joint_type']
      }
    },
    {
      path: '/jointType/edit/:id',
      name: 'Edit Joint Type',
      component: CreateJointType,
      meta: {
        toolbarTitle: 'Edit Joint Type',
        right: ['edit_joint_type']
      },
    },
    {
      path: '/polarity',
      name: 'Polarity',
      component: Polarity,
      meta: {
        toolbarTitle: 'Polarity',
      }
    },
    {
      path: '/polarity/create',
      name: 'Create Polarity',
      component: CreatePolarity,
      meta: {
        toolbarTitle: 'Create Polarity',
      }
    },
    {
      path: '/polarity/edit/:id',
      name: 'Edit Polarity',
      component: CreatePolarity,
      meta: {
        toolbarTitle: 'Edit Polarity',
      },
    },
    {
      path: '/qualificationMethod',
      name: 'QualificationMethod',
      component: QualificationMethod,
      meta: {
        toolbarTitle: 'Qualification Method',
      }
    },
    {
      path: '/qualificationMethod/create',
      name: 'Create QualificationMethod',
      component: CreateQualificationMethod,
      meta: {
        toolbarTitle: 'Create Qualification Method',
      }
    },
    {
      path: '/qualificationMethod/edit/:id',
      name: 'Edit QualificationMethod',
      component: CreateQualificationMethod,
      meta: {
        toolbarTitle: 'Edit Qualification Method',
      },
    },
    {
      path: '/referredStandard',
      name: 'ReferredStandard',
      component: ReferredStandard,
      meta: {
        toolbarTitle: 'Referred Standard',
      }
    },
    {
      path: '/referredStandard/create',
      name: 'Create ReferredStandard',
      component: CreateReferredStandard,
      meta: {
        toolbarTitle: 'Create Referred Standard',
      }
    },
    {
      path: '/referredStandard/edit/:id',
      name: 'Edit ReferredStandard',
      component: CreateReferredStandard,
      meta: {
        toolbarTitle: 'Edit Referred Standard',
      },
    },
    {
      path: '/welder',
      name: 'Welder',
      component: Welder,
      meta: {
        toolbarTitle: 'Welder',
        right: ['view_welder']
      }
    },
    {
      path: '/welder/create',
      name: 'Create Welder',
      component: CreateWelder,
      meta: {
        toolbarTitle: 'Create Welder',
        right: ['edit_welder']
      }
    },
    {
      path: '/welder/edit/:id',
      name: 'Edit Welder',
      component: CreateWelder,
      meta: {
        toolbarTitle: 'Edit Welder',
        right: ['edit_welder']
      },
    },
    {
      path: '/welder/view/:id',
      name: 'View Welder',
      component: ViewWelder,
      meta: {
        toolbarTitle: 'View Welder',
        right: ['view_welder']
      },
    },
    {
      path: '/weldingProcess',
      name: 'WeldingProcess',
      component: WeldingProcess,
      meta: {
        toolbarTitle: 'WeldingProcess',
        right: ['view_welding_process']
      }
    },
    {
      path: '/weldingProcess/create',
      name: 'Create WeldingProcess',
      component: CreateWeldingProcess,
      meta: {
        toolbarTitle: 'Create Welding Process',
        right: ['edit_welding_process']
      }
    },
    {
      path: '/weldingProcess/edit/:id',
      name: 'Edit WeldingProcess',
      component: CreateWeldingProcess,
      meta: {
        toolbarTitle: 'Edit Welding Process',
        right: ['edit_welding_process']
      },
    },
    {
      path: '/weldingType',
      name: 'WeldingType',
      component: WeldingType,
      meta: {
        toolbarTitle: 'Welding Type',
        right: ['view_welding_type']
      }
    },
    {
      path: '/weldingType/create',
      name: 'Create WeldingType',
      component: CreateWeldingType,
      meta: {
        toolbarTitle: 'Create Welding Type',
        right: ['edit_welding_type']
      }
    },
    {
      path: '/weldingType/edit/:id',
      name: 'Edit WeldingType',
      component: CreateWeldingType,
      meta: {
        toolbarTitle: 'Edit Welding Type',
        right: ['edit_welding_type']
      },
    },
    {
      path: '/project',
      name: 'Project',
      component: Project,
      meta: {
        toolbarTitle: 'Project',
        right: ['view_project']
      }
    },
    {
      path: '/project/create',
      name: 'Create Project',
      component: CreateProject,
      meta: {
        toolbarTitle: 'Create Project',
        right: ['edit_project']
      }
    },
    {
      path: '/project/edit/:id',
      name: 'Edit Project',
      component: CreateProject,
      meta: {
        toolbarTitle: 'Edit Project',
        right: ['edit_project']
      },
    },
    {
      path: '/project/view/:id',
      name: 'View Project',
      component: ViewProject,
      meta: {
        toolbarTitle: 'View Project',
        right: ['view_project']
      },
    },
    {
      path: '/weldingProcedure',
      name: 'WeldingProcedure',
      component: WeldingProcedure,
      meta: {
        toolbarTitle: 'Welding Procedure',
        right: ['view_welding_procedure']
      }
    },
    {
      path: '/weldingProcedure/create',
      name: 'Create WeldingProcedure',
      component: CreateWeldingProcedure,
      meta: {
        toolbarTitle: 'Create Welding Procedure',
        right: ['edit_welding_procedure']
      }
    },
    {
      path: '/weldingProcedure/edit/:id',
      name: 'Edit WeldingProcedure',
      component: CreateWeldingProcedure,
      meta: {
        toolbarTitle: 'Edit Welding Procedure',
        right: ['edit_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/wpsAws/create',
      name: 'Create WpsAws',
      component: WpsAws,
      meta: {
        toolbarTitle: 'Create WpsAws',
        right: ['edit_welding_procedure']
      }
    },
    {
      path: '/weldingProcedure/wpsAws/edit/:id',
      name: 'Edit WpsAws',
      component: WpsAws,
      meta: {
        toolbarTitle: 'Edit WpsAws',
        right: ['edit_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/wpsAws/view/:id',
      name: 'View WpsAws',
      component: WpsAwsView,
      meta: {
        toolbarTitle: 'View WpsAws',
        right: ['view_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/wpsAsme/create',
      name: 'Create WpsAsme',
      component: WpsAsme,
      meta: {
        toolbarTitle: 'Create WpsAsme',
        right: ['edit_welding_procedure']
      }
    },
    {
      path: '/weldingProcedure/wpsAsme/edit/:id',
      name: 'Edit WpsAsme',
      component: WpsAsme,
      meta: {
        toolbarTitle: 'Edit WpsAsme',
        right: ['edit_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/wpsAsme/view/:id',
      name: 'View WpsAsme',
      component: WpsAsmeView,
      meta: {
        toolbarTitle: 'View WpsAsme',
        right: ['view_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/pqrAsme/create',
      name: 'Create PqrAsme',
      component: PqrAsme,
      meta: {
        toolbarTitle: 'Create PqrAsme',
        right: ['edit_welding_procedure']
      }
    },
    {
      path: '/weldingProcedure/pqrAsme/edit/:id',
      name: 'Edit PqrAsme',
      component: PqrAsme,
      meta: {
        toolbarTitle: 'Edit PqrAsme',
        right: ['edit_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/pqrAsme/view/:id',
      name: 'View PqrAsme',
      component: PqrAsmeView,
      meta: {
        toolbarTitle: 'View PqrAsme',
        right: ['view_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/pqrAws/create',
      name: 'Create PqrAws',
      component: PqrAws,
      meta: {
        toolbarTitle: 'Create PqrAws',
        right: ['edit_welding_procedure']
      }
    },
    {
      path: '/weldingProcedure/pqrAws/edit/:id',
      name: 'Edit PqrAws',
      component: PqrAws,
      meta: {
        toolbarTitle: 'Edit PqrAws',
        right: ['edit_welding_procedure']
      },
    },
    {
      path: '/weldingProcedure/pqrAws/view/:id',
      name: 'View PqrAws',
      component: PqrAwsView,
      meta: {
        toolbarTitle: 'View PqrAws',
        right: ['view_welding_procedure']
      },
    },
    {
      path: '/prefix',
      name: 'Prefix',
      component: Prefix,
      meta: {
        toolbarTitle: 'Prefix',
        right: ['view_prefix']
      }
    },
    {
      path: '/prefix/create',
      name: 'Create Prefix',
      component: CreatePrefix,
      meta: {
        toolbarTitle: 'Create Prefix',
        right: ['edit_prefix']
      }
    },
    {
      path: '/prefix/edit/:id',
      name: 'Edit Prefix',
      component: CreatePrefix,
      meta: {
        toolbarTitle: 'View Prefix',
        right: ['edit_prefix']
      }
    },
    {
      path: '/prefix/view/:id',
      name: 'View Prefix',
      component: ViewPrefix,
      meta: {
        toolbarTitle: 'View Prefix',
        right: ['view_prefix']
      }
    },
    {
      path: '/cqaReport',
      name: 'Cumulative Quality Analysis',
      component: CqaReport,
      meta: {
        toolbarTitle: 'Cumulative Quality Analysis',
        right: ['cumulative_quality_analysis']
      }
    },
    {
      path: '/mvqaReport',
      name: 'Machine Vise Quality Analysis',
      component: MvqaReport,
      meta: {
        toolbarTitle: 'Machine Vise Quality Analysis',
        right: ['machine_vise_quality_analysis']
      }
    },
    {
      path: '/wlaReport',
      name: 'Welder Analysis',
      component: WlaReport,
      meta: {
        toolbarTitle: 'Welder Analysis',
        right: ['welder_analysis']
      }
    },
    {
      path: '/cmaReport',
      name: 'Cumulative Maintainance Analysis',
      component: CmaReport,
      meta: {
        toolbarTitle: 'Cumulative Maintainance Analysis',
        right: ['cumulative_maintainance_analysis']
      }
    },
    {
      path: '/pcaReport',
      name: 'Project Cost Analysis',
      component: PcaReport,
      meta: {
        toolbarTitle: 'Project Cost Analysis',
        right: ['project_cost_analysis']
      }
    },
    {
      path: '/muaReport',
      name: 'Machine Usage Analysis',
      component: MuaReport,
      meta: {
        toolbarTitle: 'Machine Usage Analysis',
        right: ['machine_usage_analysis']
      }
    },
    {
      path: '/ptcaReport',
      name: 'Project Time Cost Quality Analysis',
      component: PtcaReport,
      meta: {
        toolbarTitle: 'Project Time Cost Quality Analysis',
        right: ['project_time_cost_quality_analysis']
      }
    },
    {
      path: '/companyProfile',
      name: 'Company Profile',
      component: CompanyProfile,
      meta: {
        toolbarTitle: 'Company Profile',
        right: ['manage_company_profile']
      }
    },
    {
      path: '*',
      redirect: { name: '404' }
    },
    {
      path: '/401',
      name: '401',
      component: NotAuthorized,
    },
    {
      path: '/404',
      name: '404',
      component: ErrorPage,
    },
    {
      path: '/getAppData',
      name: 'GetAppData',
      component: GetAppData
    }
  ]
})

route.beforeEach((to, from, next) => {
  // console.log(from)
  if (!Object.prototype.hasOwnProperty.call(to.meta, 'requiresAuth') || to.meta.requiresAuth === true) {
    if (!Vue.prototype.$isUserLoggedIn()) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
        replace: true,
      })
    }
  }
  if (globalUserData.$data.USERRIGHT.length > 0 && to.meta !== undefined && to.meta.right !== undefined) {
    let flag = false
    to.meta.right.map((val) => {
      if (globalUserData.$data.USERRIGHT.indexOf(val) > -1) {
        flag = true
        return false
      }
    })
    if (!flag) {
      next({
        name: '401',
      })
    }
  }
  next()
})

export default route
